import { isValidDate } from "../../../../utils/isValidDate";
import { AssetOwnClaimsTab, SaveAssetOwnClaims } from "../../../api/ClientFileApi";
import { AssetOwnClaimsFormValues, OwnClaimFormValue } from "./OwnClaimsView.types";

export function createEmptyOwnClaim(key: string): OwnClaimFormValue {
  return {
    key,
    id: null,
    debtorName: null,
    debtorAddress: null,
    isRelated: null,
    relationship: null,
    legalReason: null,
    amount: null,
    dueDate: null,
    isSecured: null,
    securities: null,
    isDisputed: null,
    hasPendingCourtProceedings: null,
    disputeDetails: null,
    isCollectible: null,
    collectionSteps: null,
  };
}

export function fromOwnClaimsResponse(data: AssetOwnClaimsTab | undefined): AssetOwnClaimsFormValues {
  return {
    hasOwnClaims: data?.hasOwnClaims ?? null,
    ownClaims: (data?.ownClaims ?? []).map((claim) => ({
      key: claim.id,
      id: claim.id,
      debtorName: claim.debtorName ?? null,
      debtorAddress: claim.debtorAddress ?? null,
      isRelated: claim.isRelated ?? null,
      relationship: claim.relationship ?? null,
      legalReason: claim.legalReason ?? null,
      amount: claim.amount ?? null,
      dueDate: claim.dueDate ?? null,
      isSecured: claim.isSecured ?? null,
      securities: claim.securities ?? null,
      isDisputed: claim.isDisputed ?? null,
      hasPendingCourtProceedings: claim.hasPendingCourtProceedings ?? null,
      disputeDetails: claim.disputeDetails ?? null,
      isCollectible: claim.isCollectible ?? null,
      collectionSteps: claim.collectionSteps ?? null,
    })),
    ownClaimDocuments: [],
    documentMoves: [],
  };
}

export function toOwnClaimsRequest(values: AssetOwnClaimsFormValues): SaveAssetOwnClaims {
  return {
    hasOwnClaims: values.hasOwnClaims,
    ownClaims: values.ownClaims.map(({ key: _key, dueDate, ...claim }) => ({
      ...claim,
      dueDate: isValidDate(dueDate) ? dueDate : null,
    })),
  };
}
